<template>
    <div>
        <table-tool-bar>
            <template slot="left">
                <span :class="preCls + 'filter-label'" style="margin-left: 10px">开始日期</span>
                <DatePicker
                    v-model="startDate"
                    :class="preCls + 'select-public-style'"
                    transfer
                    type="date"
                    @on-change="search"
                ></DatePicker>
                <span :class="preCls + 'filter-label'">结束日期</span>
                <DatePicker
                    v-model="endDate"
                    :class="preCls + 'select-public-style'"
                    transfer
                    type="date"
                    @on-change="search"
                ></DatePicker>
                <check-tag-group
                    v-model="fastDate"
                    style="display: inline-block"
                    color="primary"
                    @on-change="getEndStart"
                >
                    <check-tag
                        v-for="item in fastDateList"
                        :name="item.id"
                        :key="item.id"
                    >{{item.text}}</check-tag>
                </check-tag-group>
            </template>
        </table-tool-bar>
        <Table ref="mt" :columns="columns" :data="page.list" :loading="loading" :height="mtHeight">
            <template v-slot:score="{ row }">
                <Rate show-text allow-half v-model="row.score" disabled>
                    <span :style="{color: variables.linkColor}">{{ row.score || 0 }}</span>分
                </Rate>
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager
            :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            @change="fetch"
        ></table-pager>
        <!-- 弹出层 -->
    </div>
</template>
<script>
import { ymd } from '@/utils/helper'
import { orderEvaluate, customerDelete } from '@/api/order-manage'
import dayjs from 'dayjs'
import { Rate } from 'ivux'
const PAGE_SIZE = 20

const fetchData = function() {
    return Promise.all([
        orderEvaluate({
            pageNo: 1,
            pageSize: PAGE_SIZE
        })
    ])
}

export default {
    name: 'ListEvaluate',

    components: { Rate },

    data() {
        return {
            mtHeight: 360,
            loading: false,
            filter: {
                pageNo: 1,
                pageSize: PAGE_SIZE,
                startDate: this.$cache.startDate,
                endDate: this.$cache.endDate
            },
            page: {
                total: 0,
                list: []
            },
            dict: {},
            modal: {},
            curId: '',
            fastDateList: [
                { id: 7, text: '近7天' },
                { id: 30, text: '近30天' },
                { id: 90, text: '近90天' }
            ],
            fastDate: []
        }
    },

    computed: {
        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 60
                },
                {
                    key: 'customerName',
                    title: '客户名称',
                    align: 'left',
                    minWidth: 150,
                    tooltip: true
                },
                {
                    key: 'orderNo',
                    title: '工单号',
                    align: 'left',
                    minWidth: 180
                },
                {
                    key: 'createUserName',
                    title: '报单人',
                    align: 'left',
                    minWidth: 100
                },
                {
                    key: 'execUserName',
                    title: '执行人',
                    align: 'left',
                    minWidth: 100
                },
                {
                    key: 'score',
                    title: '服务评分',
                    align: 'left',
                    minWidth: 220,
                    slot: 'score'
                },
                {
                    key: 'acceptAssess',
                    title: '服务意见',
                    align: 'left',
                    minWidth: 200,
                    tooltip: true
                }
            ]
        },

        startDate: {
            get() {
                return this.filter.startDate
                    ? new Date(this.filter.startDate)
                    : ''
            },
            set(val) {
                this.filter.startDate = ymd(val)
            }
        },

        endDate: {
            get() {
                return this.filter.endDate ? new Date(this.filter.endDate) : ''
            },
            set(val) {
                this.filter.endDate = ymd(val)
            }
        }
    },

    watch: {
        'filter.startDate': function(val) {
            this.$cache.startDate = val
        },
        'filter.endDate': function(val) {
            this.$cache.endDate = val
        }
    },
    created() {
        this.fetch()
    },

    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },

    methods: {
        fetch() {
            this.loading = true

            Promise.all([orderEvaluate(this.filter)])
                .then(args => {
                    var [page] = args

                    this.setPageData(page.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },

        search() {
            this.filter.pageNo = 1
            this.fetch()
        },
        setPageData(data) {
            this.page.list = data.page.list
            this.page.total = parseInt(data.page.totalCount)
        },
        fillData(args) {
            var [page] = args
            this.setPageData(page.data)
        },

        clearFast() {
            this.fastDate = []
        },
        getEndStart(el) {
            if (el && el.length) {
                this.filter.startDate = dayjs()
                    .subtract(el[0], 'day')
                    .format('YYYY-MM-DD')
                this.filter.endDate = dayjs().format('YYYY-MM-DD')
                this.search()
            }
        }
    }
}
</script>
<style lang="less" 
    scoped>
</style>